<template>
  <div id="app">
    <myheader></myheader>
    <router-view></router-view>
    <myfooter></myfooter>
  </div>
</template>

<script>
import myheader from './components/myheader'
import myfooter from './components/myfooter'
export default {
  name: 'App',
  components:{
    myheader,
    myfooter
  }
}
</script>

<style>
*{
  font-family: 微軟正黑體;
}
a :hover{
    color:#003567;
}
</style>



// WEBPACK FOOTER //
// src/App.vue